export const FALLBACKLNG = ["en"];
/*export const AVAILABLELANGUAGES = [
    {id:0, lang:'en'},
    {id:1, lang:'ru'},
    {id:2, lang:'it'}];*/
export const AVAILABLELANGUAGES = window.Bagbnb
  ? window.Bagbnb.locales
  : [
      {
        apiUriprefix: "en",
        baseAirportTransferPrefix: "/airport-transfers/",
        baseLuggageStoragePrefix: "/luggage-storage/",
        htmlUriPrefix: "",
        id: "en",
        locale: "en-GB",
        name: "English",
        weight: 0,
      },
    ];

export const API =
  (window.Bagbnb && window.Bagbnb.apiUrl) || "https://api.storage.radical.run/";
export const ANGEL_APP_CALENDAR_URL =
  window.Bagbnb && window.Bagbnb.angelAppCalendarUrl;
//export const ANGEL_APP_CALENDAR_URL = (window.Bagbnb && window.Bagbnb.angelAppCalendarUrl) || "http://radical.local:8088";
export const BOOKING_API =
  (window.Bagbnb && window.Bagbnb.bookingApiUrl) ||
  "https://api.storage.radical.run/bookings/";
export const ORGANIZATION_API =
  (window.Bagbnb && window.Bagbnb.organizationApiUrl) ||
  "https://api.storage.radical.run/organization/";
export const API_CATALOG_API =
  (window.Bagbnb && window.Bagbnb.catalogApiUrl) ||
  "https://api.storage.radical.run/api-catalog/";
export const API_V3 =
  (window.Bagbnb && window.Bagbnb.apiV3Url) ||
  "https://storage.radical.run/v3/";
export const DOMAIN =
  (window.Bagbnb && window.Bagbnb.domain) || "https://storage.radical.run";
export const SENTRY =
  (window.Bagbnb && window.Bagbnb.sentry) ||
  "https://50e00349cdaf4355a6b271b89dbcd830@o165309.ingest.sentry.io/5219271";
export const assetsStaticURL = "https://assets.radical.storage/static/";

export const baseURL =
  (window.Bagbnb && window.Bagbnb.domain.split("//")[1]) ||
  "stg.radical.storage";

export const MAP_TILER_KEY =
  (window.Bagbnb && window.Bagbnb.mapTilerKey) || "FzrTVDWnzVpPaUgUUXYo";

/*export const API = 'https://api.bagbnb.com/';
export const API_V3 = 'https://bagbnb.com/v3/';
export const DOMAIN = 'http://bagbnb.local';*/

export const PUBLIC_URL = process.env.PUBLIC_URL;

//export const COMPANY_STATIC_FIELDS = ["name", "country", "address", "email", "owner", "vat"]; deprecated old API logic
export const COMPANY_STATIC_FIELDS = [
  "vat",
  "country",
  "company_name",
  "owner",
  "address",
  "city",
  "district",
  "postal_code",
  "unique_code",
];
export const COMPANY_DEFAULT_COUNTRY = "it";
export const OLD_COMPANY_DYNAMIC_FIELDS = [
  "fiscal_code",
  "nif",
  "cuil_cuit",
  "unique_code",
  "certified_email",
  "vat",
  "italian_province",
]; //should be deprecated old API logic
export const COMPANY_DYNAMIC_FIELDS = ["italian_province", "certified_email"];

export const COMPANY_FIELDS_NAMES = {
  // vat: { label: "VAT", placeholder: 'Insert your VAT' },
  account_holder_cyrillic:
      {label: 'Account holder cyrillic', placeholder: 'Insert your Account holder cyrillic'},
  account_number:
      { 
        label: 'Account number',
        placeholder: 'Insert your Account number',
        labelByCountryAndCurrency: {
          br_USD: 'US$ Account number',
          br_BRL: 'Conta corrente',
        },
      },
  account_type:
      {label: 'Account type', placeholder: 'Insert your Account type'},
  bank_account_name:
      {
        label: 'Account holder', 
        placeholder: 'Insert your Bank account name',
        labelByCountryAndCurrency: {
          br_USD: 'US$ Bank account holder',          
        },
      },
  bank_code:
      {label: 'Bank code', placeholder: 'Insert your Bank code'},
  bank_name:
      {label: 'Bank name', placeholder: 'Insert your Bank name'},
  bic:
      {
        label: 'BIC code/SWIFT code', 
        placeholder: 'Insert your BIC code/SWIFT code',
        labelByCountryAndCurrency: {
          br_BRL: 'BIC / SWIFT',
        },
      },
  bik:
      {label: 'BIK', placeholder: 'Insert your BIK'},
  branch:
      {
        label: 'Branch',
        placeholder: 'Insert your Branch',
        labelByCountryAndCurrency: {          
          br_BRL: 'Agência',
        },
      },
  bsb_code:
      {label: 'BSB code', placeholder: 'Insert your BSB code'},
  business_number:
      {label: 'Business number', placeholder: 'Insert your Business number'},
  certified_email:
      {label: 'Certified email', placeholder: 'Insert your Certified email'},
  cnpj:
      {label: 'CNPJ', placeholder: 'Insert Branch code Tax registration number (CNPJ)'},
  clabe:
      {label: 'CLABE', placeholder: 'Insert your CLABE'},
  credit_card:
      {label: 'Credit Card', placeholder: 'Insert your Credit card'},
  cuil_cuit:
      {label: 'Cuil cuit', placeholder: 'Insert your Cuil cuit'},
  curp:
      {label: 'CURP', placeholder: 'insert CURP'},
  document_type:
      {label: 'ID document type', placeholder: 'Insert ID document type'},
  duitnow:
      {label: 'Duitnow', placeholder: 'Insert your Duitnow'},
  e_wallet:
      {label: 'E-Wallet', placeholder: 'Insert your E-Wallet'},
  e_wallet_recipient_num:
      {label: 'Recipient E-wallet number', placeholder: 'Insert your recipient E-wallet number'},
  fedwire_number:
      {label: 'Fedwire number', placeholder: 'Insert Fedwire number'},
  fedwire_routing_number:
      {label: 'Fedwire routing number', placeholder: 'Insert Fedwire routing number'},
  fiscal_code:
      {label: 'Fiscal code', placeholder: 'Insert your Fiscal code'},
  fps:
      {label: 'FPS', placeholder: 'Insert your FPS'},
  iban:
      {label: 'IBAN', placeholder: 'Insert your IBAN'},
  institution_number:
      {label: 'Institution number', placeholder: 'Insert your Institution number'},
  italian_province:
      {label: 'Italian province', placeholder: 'Insert italian province'},
  krw_account_number:
      {label: 'KRW account number', placeholder: 'Insert your KRW account number'},
  legal_type:
      {label: 'Legal type', placeholder: 'Insert your Legal type'},
  national_id_number:
      {label: 'National ID number', placeholder: 'Insert your National ID number'},
  nif:
      {label: 'NIF', placeholder: 'Insert your NIF'},
  nric:
      {label: 'NRIC', placeholder: 'Insert your NRIC (for PayNow)'},
  paynow:
      {label: 'PayNow', placeholder: 'Insert your PayNow'},
  paypal_account:
      {label: 'Paypal account', placeholder: 'Insert your Paypal account'},
  phone:
      {label: 'Phone number', placeholder: 'Insert your Phone number'},
  recipient_bank_name:
      {label: 'Recipient bank name', placeholder: 'Insert your Recipient bank name'},
  recipient_dob:
      {label: "Recipient's date of birth", placeholder: "Insert recipient's date of birth", type: 'date'},
  recipient_id_number:
      {label: "Recipient's identification number", placeholder: "Insert recipient's identification number"},
  registration_number:
      {label: 'Registration number', placeholder: 'Insert your Registration number'},
  relationship:
      {label: 'Relationship', placeholder: 'Insert your Relationship'},
  rfc:
      {label: 'RFC', placeholder: 'Insert RFC'},
  routing_number:
      {
        label: 'Routing number', 
        placeholder: 'Insert your Routing number',
        labelByCountryAndCurrency: {
          br_USD: 'US$ Routing number',          
        },
      },
  rut_number:
      {label: 'RUT number', placeholder: 'Insert RUT number'},
  sort_code:
      {label: 'Sort code', placeholder: 'Insert your Sort code'},
  transit_number:
      {label: 'Transit number', placeholder: 'Insert your Transit number'},
  uen:
      {label: 'Unique Entity Number (UEN)', placeholder: 'Insert UEN (for PayNow)'},
  unique_code:
      {label: 'Unique code', placeholder: 'Insert your Unique code'},
  vpa:
      {label: 'VPA', placeholder: 'Insert your VPA (for PayNow)'}
}

export const COMPANY_FIELDS_BY_COUNTRY = {
  ae: ["bik", "bank_account_name", "iban", "bic", "recipient_dob", "account_type", "legal_type"],
  al: ["vat", "iban", "bank_account_name", "recipient_dob", "account_type", "legal_type"],
  am: ["account_number", "bik", "bank_account_name", "fedwire_number", "fedwire_routing_number", "routing_number", "recipient_dob", "account_type", "legal_type"],
  ar: ["cuil_cuit", "account_number", "bank_account_name", "routing_number", "recipient_dob", "account_type", "legal_type"],
  at: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  au: ["account_number", "bank_account_name", "business_number", "bsb_code", "recipient_dob", "account_type", "legal_type"],
  az: ["bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  bb: ["bank_name", "account_number", "bank_account_name", "bik", "recipient_dob", "account_type", "legal_type"],
  ba: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  be: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  bg: ["vat", "nif", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  bh: ["iban", "bank_account_name", "fedwire_number", "fedwire_routing_number", "account_number", "routing_number", "recipient_dob", "account_type", "legal_type"],
  //br: ["vat", "fiscal_code", "account_number", "bik", "bank_name", "bank_account_name", "iban", "credit_card", "routing_number", "cnpj", "recipient_dob", "account_type", "legal_type"],
  by: ["bank_account_name", "iban", "account_type", "legal_type", "recipient_dob" ],
  ca: ["vat", "account_number", "bank_account_name", "institution_number", "transit_number", "recipient_dob", "account_type", "legal_type"],
  cl: ["vat", "account_number", "bik", "bank_account_name", "rut_number", "bank_name", /*"phone",*/ "recipient_dob", "account_type", "legal_type"],
  cn: ["bank_account_name", "account_number", "bik", "recipient_dob", "account_type", "legal_type"],
  co: ["bank_name", "bank_account_name", "account_number", /*"phone",*/ "fedwire_number", "fedwire_routing_number", "routing_number", "recipient_dob", "account_type", "legal_type"],
  cr: ["vat", "account_number", "bank_account_name", "bik", "recipient_dob", "account_type", "legal_type"],
  cu: ["account_type", "bank_name", "bank_account_name", "account_number", "iban", "recipient_dob", "legal_type"],
  cy: ["vat", "iban", "bank_account_name", "recipient_dob", "account_type", "legal_type"],
  cz: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  de: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  dk: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  do: ["bank_name", "bank_account_name", "account_number", "bik", "routing_number", "recipient_dob", "account_type", "legal_type"],
  ec: ["vat", "account_number", "bank_name", "bik", "bank_account_name", "fedwire_number", "fedwire_routing_number", "routing_number", "recipient_dob", "account_type", "legal_type"],
  ee: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  eg: ["bank_name", "bank_account_name", "iban", "bik", "recipient_dob", "account_type", "legal_type"],
  es: ["vat", "bik", "bank_account_name", "iban", "nif", "recipient_dob", "account_type", "legal_type"],
  fi: ["vat", "nif", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  fr: ["vat", "fiscal_code", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  ge: ["bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  gr: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  gt: ["account_number", "bank_account_name", "recipient_dob", "account_type", "legal_type"],
  hk: ["vat", "account_number", "bank_name", "bank_account_name", "recipient_dob", "account_type", "legal_type"],
  hr: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  hu: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  id: ["bank_account_name", "account_number", "bik", "bank_name", "recipient_dob", "account_type", "legal_type"],
  ie: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  il: ["vat", "iban", "bank_account_name", "credit_card", "recipient_dob", "account_type", "legal_type"],
  it: ["vat", "fiscal_code", "unique_code", "certified_email", "bank_account_name", "iban", "italian_province", "recipient_dob", "account_type", "legal_type"],
  jo: ["iban", "bank_account_name", "recipient_dob", "account_type", "legal_type"],
  jp: ["vat",  "bank_account_name", "account_number", "bank_name", "bank_code", "bik", "branch", "account_type", "legal_type", "recipient_dob"],
  ke: ["bank_name", "account_number", "bank_account_name", "bik", "credit_card", "recipient_dob", "account_type", "legal_type"],
  kr: ["vat", "bank_account_name", "krw_account_number", "bank_name", "bic", "recipient_bank_name", "bik", /*"phone",*/ "recipient_dob", "account_type", "legal_type"],
  lt: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  lu: ["vat", "iban", "bank_account_name", "recipient_dob", "account_type", "legal_type"],
  lv: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  ma: ["vat", "account_number", "bik", "bank_account_name", "bank_name", "recipient_dob", "account_type", "legal_type"],
  md: ["bank_account_name", "iban", "account_type", "legal_type", "recipient_dob"],
  me: ["vat", "iban", "bank_account_name", "recipient_dob", "account_type", "legal_type"],
  mk: ["vat", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  mt: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  mx: ["vat", "account_number", "bik", "clabe", "bank_account_name", "rfc", "curp", "recipient_dob", "account_type", "legal_type"],
  my: ["vat", "account_number", "bank_name", "bank_account_name", "recipient_bank_name", "bik", "duitnow", "recipient_dob", "account_type", "legal_type"],
  nl: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  np: ["account_number", "bank_name", "bank_account_name", /*"phone",*/ "document_type", "recipient_id_number", "recipient_dob", "account_type", "legal_type"],
  nz: ["account_number", "bank_account_name", "recipient_dob", "account_type", "legal_type"],
  pa: ["account_number", "bank_account_name", "routing_number", "recipient_dob", "account_type", "legal_type"],
  pe: ["vat", "account_number", "bank_account_name", /*"phone",*/ "document_type", "recipient_id_number", "recipient_dob", "bank_name", "routing_number", "account_type", "legal_type"],
  pf: ["vat", "account_number", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  ph: ["vat", "account_number", "bank_name", "bank_account_name", "e_wallet", "e_wallet_recipient_num", "recipient_dob", "account_type", "legal_type"],
  pl: ["vat", "nif", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  pr: ["bank_account_name", "account_number", "bank_name", "routing_number", "recipient_dob", "account_type", "legal_type"],
  pt: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  qa: ["account_number", "bank_account_name", "iban", "bic", "recipient_dob", "account_type", "legal_type"],
  ro: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  rs: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  ru: ["vat", "account_number", "bik", "account_holder_cyrillic", "bank_account_name", "credit_card", "recipient_dob", "account_type", "legal_type"],
  se: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  sg: ["vat", "account_number", "bik", "bank_name", "bank_account_name", "recipient_bank_name", /*"phone",*/ "recipient_dob", "account_type", "legal_type"],
  si: ["vat", "iban", "bank_account_name", "recipient_dob", "account_type", "legal_type"],
  sk: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  sv: ["bank_account_name", "account_number", "recipient_dob", "account_type", "legal_type"],
  th: ["account_number", "bank_name", "bank_account_name", "bik", "bic", "recipient_dob", "account_type", "legal_type"],
  tr: ["vat", "bank_account_name", "iban", "credit_card", "recipient_dob", "account_type", "legal_type"],
  tw: ["bank_account_name", "account_number", "bank_name", "bik", "recipient_dob", "account_type", "legal_type"],
  ua: ["vat", "nif", "account_number", "bik", "bank_account_name", "iban", "credit_card", "recipient_dob", "account_type", "legal_type"],
  gb: ["vat", "account_number", "bank_account_name", "iban", "sort_code", "recipient_dob", "account_type", "legal_type"],
  us: ["vat", "account_number", "bank_account_name", "routing_number", "recipient_dob", "account_type", "legal_type"],
  vn: ["vat", "account_number", "bank_account_name", "credit_card", "bank_code", "bic", "recipient_dob", "account_type", "legal_type"],
  uy: ["account_number", "bank_account_name", "bik", "bank_name", "branch", "recipient_dob", "account_type", "legal_type"],
  xk: ["vat", "bik", "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  za: ["vat", "account_number", "branch", "bank_name", "bank_account_name", /*"phone",*/ "recipient_dob", "account_type", "legal_type"],

  other: ["bank_account_name", "account_number", "routing_number", "account_type", "legal_type", "recipient_dob"],

  ad: [ "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  ch: [ "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  gg: [ "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  gi: [ "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  im: [ "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  is: [ "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  li: [ "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  mc: [ "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  no: [ "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  sm: [ "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],
  va: [ "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"],

  el: [ "bank_account_name", "iban", "recipient_dob", "account_type", "legal_type"]

};

export const MANDATORY_PAYMENT_FIELDS_BY_COUNTRY = {
  // European countries first
  at: ["bank_account_name", "iban", "account_type", "legal_type"],
  az: ["bank_account_name", "iban", "account_type", "legal_type"],
  ba: ["bank_account_name", "iban", "account_type", "legal_type"],
  be: ["bank_account_name", "iban", "account_type", "legal_type"],
  bg: ["bank_account_name", "iban", "account_type", "legal_type"],
  by: ["bank_account_name", "iban", "account_type", "legal_type"],
  cy: ["bank_account_name", "iban", "account_type", "legal_type"],
  cz: ["bank_account_name", "iban", "account_type", "legal_type"],
  de: ["bank_account_name", "iban", "account_type", "legal_type"],
  dk: ["bank_account_name", "iban", "account_type", "legal_type"],
  ee: ["bank_account_name", "iban", "account_type", "legal_type"],
  es: ["bank_account_name", "iban", "account_type", "legal_type"],
  fi: ["bank_account_name", "iban", "account_type", "legal_type"],
  fr: ["bank_account_name", "iban", "account_type", "legal_type"],
  gb: ["bank_account_name", "account_number", "sort_code", "account_type", "legal_type"],
  ge: ["bank_account_name", "iban", "account_type", "legal_type"],
  gr: ["bank_account_name", "iban", "account_type", "legal_type"],
  hr: ["bank_account_name", "iban", "account_type", "legal_type"],
  hu: ["bank_account_name", "iban", "account_type", "legal_type"],
  ie: ["bank_account_name", "iban", "account_type", "legal_type"],
  it: ["bank_account_name", "iban", "account_type", "legal_type"],
  lt: ["bank_account_name", "iban", "account_type", "legal_type"],
  lu: ["bank_account_name", "iban", "account_type", "legal_type"],
  lv: ["bank_account_name", "iban", "account_type", "legal_type"],
  md: ["bank_account_name", "iban", "account_type", "legal_type"],
  me: ["bank_account_name", "iban", "account_type", "legal_type"],
  mk: ["bank_account_name", "iban", "account_type", "legal_type"],
  mt: ["bank_account_name", "iban", "account_type", "legal_type"],
  nl: ["bank_account_name", "iban", "account_type", "legal_type"],
  pl: ["bank_account_name", "iban", "account_type", "legal_type"],
  pt: ["bank_account_name", "iban", "account_type", "legal_type"],
  ro: ["bank_account_name", "iban", "account_type", "legal_type"],
  rs: ["bank_account_name", "iban", "account_type", "legal_type"],
  ru: ["bank_account_name", "account_type", "legal_type", "account_number", "bik", "account_holder_cyrillic" ],
  se: ["bank_account_name", "iban", "account_type", "legal_type"],
  si: ["bank_account_name", "iban", "account_type", "legal_type"],
  sk: ["bank_account_name", "iban", "account_type", "legal_type"],
  tr: ["bank_account_name", "iban", "account_type", "legal_type"],
  ua: ["bank_account_name", "iban", "account_type", "legal_type"],
  xk: ["bank_account_name", "iban", "account_type", "legal_type"],

  // Rest of the world alphabetically
  ae: ["bank_account_name", "iban", "bic", "account_type", "legal_type"],
  al: ["bank_account_name", "iban", "account_type", "legal_type"],
  am: ["bank_account_name", "account_number", "routing_number", "account_type", "legal_type"],
  ar: ["bank_account_name", "account_number", "routing_number", "account_type", "legal_type"],
  au: ["bank_account_name", "account_number", "bsb_code", "account_type", "legal_type"],
  bb: ["bank_account_name", "account_number", "bik", "bank_name", "account_type", "legal_type"],
  bh: ["bank_account_name", "account_number", "routing_number", "account_type", "legal_type"],
  br: ["bank_account_name", "account_number", "routing_number", "account_type", "legal_type", "recipient_dob", "cnpj", "branch", "bank_code" ],
  ca: ["bank_account_name", "account_number", "institution_number", "transit_number", "account_type", "legal_type"],
  cl: ["bank_account_name", "account_number", "bank_name", "rut_number", /*"phone",*/ "account_type", "legal_type"],
  cn: ["bank_account_name", "account_number", "bik", "account_type", "legal_type"],
  co: ["bank_account_name", "account_number", "bank_name", /*"phone",*/ "account_type", "legal_type"],
  cr: ["bank_account_name", "account_number", "bik", "account_type", "legal_type"],
  cu: ["bank_account_name", "account_number", "bank_name", "account_type", "legal_type"],
  do: ["bank_account_name", "account_number", "routing_number", "account_type", "legal_type"],
  ec: ["bank_account_name", "account_number", "routing_number", "account_type", "legal_type"],
  eg: ["bank_account_name", "iban", "account_type", "legal_type"],
  gt: ["bank_account_name", "account_number", "account_type", "legal_type"],
  hk: ["bank_account_name", "account_number", "bank_name", "account_type", "legal_type"],
  id: ["bank_account_name", "account_number", "bank_name", "account_type", "legal_type"],
  il: ["bank_account_name", "iban", "account_type", "legal_type"],
  jo: ["bank_account_name", "iban", "account_type", "legal_type"],
  jp: ["bank_account_name", "account_number", "bank_name", "bank_code", "branch", "account_type", "legal_type"],
  ke: ["bank_account_name", "account_number", "bik", "bank_name", "account_type", "legal_type"],
  kr: ["bank_account_name", "krw_account_number", "bank_name", "bic", "account_type", "legal_type"],
  ma: ["bank_account_name", "account_number", "bank_name", "account_type", "legal_type"],
  mx: ["bank_account_name", "clabe", "account_type", "legal_type"],
  my: ["bank_account_name", "account_number", "bank_name", "account_type", "legal_type"],
  np: ["bank_account_name", "account_number", "bank_name", /*"phone",*/ "document_type", "recipient_id_number", "account_type", "legal_type"],
  nz: ["bank_account_name", "account_number", "account_type", "legal_type"],
  pa: ["bank_account_name", "account_number", "routing_number", "account_type", "legal_type"],
  pe: ["bank_account_name", "account_number", "routing_number" , "account_type", "legal_type"],
  pf: ["bank_account_name", "iban", "account_type", "legal_type"],
  ph: ["bank_account_name", "account_number", "bank_name", "account_type", "legal_type"],
  qa: ["bank_account_name", "iban", "bic", "account_type", "legal_type"],
  sg: ["bank_account_name", "account_number", "bank_name", "account_type", "legal_type"],
  sv: ["bank_account_name", "account_number", "account_type", "legal_type"],
  th: ["bank_account_name", "account_number", "bic", "bank_name", "account_type", "legal_type"],
  tw: ["bank_account_name", "account_number", "bik", "bank_name", "account_type", "legal_type"],
  us: ["bank_account_name", "account_number", "routing_number", "account_type", "legal_type"],
  uy: ["bank_account_name", "account_number", "bank_name", "branch", "account_type", "legal_type"],
  vn: ["bank_account_name", "account_number", "bank_code", "bic", "account_type", "legal_type"],
  za: ["bank_account_name", "account_number", "bank_name", /*"phone",*/ "account_type", "legal_type"],

  other:["bank_account_name", "account_number", "routing_number", "account_type", "legal_type"],

  ad: [ "bank_account_name", "iban", "account_type", "legal_type"],
  ch: [ "bank_account_name", "iban", "account_type", "legal_type"],
  gg: [ "bank_account_name", "iban", "account_type", "legal_type"],
  gi: [ "bank_account_name", "iban", "account_type", "legal_type"],
  im: [ "bank_account_name", "iban", "account_type", "legal_type"],
  is: [ "bank_account_name", "iban", "account_type", "legal_type"],
  li: [ "bank_account_name", "iban", "account_type", "legal_type"],
  mc: [ "bank_account_name", "iban", "account_type", "legal_type"],
  no: [ "bank_account_name", "iban", "account_type", "legal_type"],
  sm: [ "bank_account_name", "iban", "account_type", "legal_type"],
  va: [ "bank_account_name", "iban", "account_type", "legal_type"],

  el: [ "bank_account_name", "iban", "account_type", "legal_type"]
};

/*DOB is mandatory for PRIVATE for all countries when legal_type is PRIVATE
so will not be added to the list*/
export const MANDATORY_PAYMENT_FIELDS_BY_COUNTRY_AND_LEGAL_TYPE = {
  uy: {
    PRIVATE: ["national_id_number"],
    BUSINESS: ["rut_number"],
  },
  za: {
    BUSINESS: ["registration_number"],
  },
  vn: {
    BUSINESS: ["relationship"],
  },
};

/*Every country has paypal as alternative payment method so it will be not added to the list*/
export const ALTERNATIVE_PAYMENT_FIELDS_BY_COUNTRY = {
  mx: ['rfc', 'curp'],
  sg: ['nric', 'uen', 'vpa' ], //'phone' //paynow in doc
  my: ['duitnow'],
  ph: ['e_wallet'],
  hk: ['fps'],
  id: ['e_wallet'],
};

export const COUNTRIES_WITH_FIELDS_BY_CURRENCY = {
  br: {
    'ALL' : ['bank_account_name','account_number','routing_number','account_type','legal_type', 'recipient_dob', 'cnpj', 'branch', 'bank_code', 'bic', 'wise_accepted_currency'],
    'USD' : ['bank_account_name','account_number','routing_number','account_type','legal_type', 'recipient_dob'],
    'BRL' : ['bank_account_name','account_number','cnpj', 'branch', 'bank_code', 'bic', 'account_type', 'legal_type']
  },
  
};

export const EU_COUNTRIES = [
  "at",
  "be",
  "bg",
  "cy",
  "cz",
  "de",
  "dk",
  "ee",
  "es",
  "fi",
  "fr",
  "gr",
  "hr",
  "hu",
  "ie",
  //"it", // we are not sure but there are some conditions for EU_COUNTRIES and all tested without It inside this list
  "lt",
  "lu",
  "lv",
  "mt",
  "nl",
  "pl",
  "pt",
  "ro",
  "se",
  "si",
  "sk",
];

export const PAGINATION_PAGE_SIZE = {
  common: 10,
  orders: 5,
};

export const ITALIAN_PROVINCES = [
  { value: "-", label: "select province", isDisabled: true },
  { value: "TO", label: "Torino (province), Piemonte" },
  { value: "VC", label: "Vercelli (province), Piemonte" },
  { value: "NO", label: "Novara (province), Piemonte" },
  { value: "CN", label: "Cuneo (province), Piemonte" },
  { value: "AT", label: "Asti (province), Piemonte" },
  { value: "AL", label: "Alessandria (province), Piemonte" },
  { value: "BI", label: "Biella (province), Piemonte" },
  { value: "VB", label: "Verbano-Cusio-Ossola (province), Piemonte" },
  {
    value: "AO",
    label:
      "Valle d'Aosta/Vallée d'Aoste (province), Valle d'Aosta/Vallée d'Aoste",
  },
  { value: "VA", label: "Varese (province), Lombardia" },
  { value: "CO", label: "Como (province), Lombardia" },
  { value: "SO", label: "Sondrio (province), Lombardia" },
  { value: "MI", label: "Milano (province), Lombardia" },
  { value: "BG", label: "Bergamo (province), Lombardia" },
  { value: "BS", label: "Brescia (province), Lombardia" },
  { value: "PV", label: "Pavia (province), Lombardia" },
  { value: "CR", label: "Cremona (province), Lombardia" },
  { value: "MN", label: "Mantova (province), Lombardia" },
  { value: "LC", label: "Lecco (province), Lombardia" },
  { value: "LO", label: "Lodi (province), Lombardia" },
  { value: "MB", label: "Monza e della Brianza (province), Lombardia" },
  {
    value: "BZ",
    label: "Bolzano/Bozen (province), Trentino-Alto Adige/Südtirol",
  },
  { value: "TN", label: "Trento (province), Trentino-Alto Adige/Südtirol" },
  { value: "VR", label: "Verona (province), Veneto" },
  { value: "VI", label: "Vicenza (province), Veneto" },
  { value: "BL", label: "Belluno (province), Veneto" },
  { value: "TV", label: "Treviso (province), Veneto" },
  { value: "VE", label: "Venezia (province), Veneto" },
  { value: "PD", label: "Padova (province), Veneto" },
  { value: "RO", label: "Rovigo (province), Veneto" },
  { value: "UD", label: "Udine (province), Friuli-Venezia Giulia" },
  { value: "GO", label: "Gorizia (province), Friuli-Venezia Giulia" },
  { value: "TS", label: "Trieste (province), Friuli-Venezia Giulia" },
  { value: "PN", label: "Pordenone (province), Friuli-Venezia Giulia" },
  { value: "IM", label: "Imperia (province), Liguria" },
  { value: "SV", label: "Savona (province), Liguria" },
  { value: "GE", label: "Genova (province), Liguria" },
  { value: "SP", label: "La Spezia (province), Liguria" },
  { value: "PC", label: "Piacenza (province), Emilia-Romagna" },
  { value: "PR", label: "Parma (province), Emilia-Romagna" },
  { value: "RE", label: "Reggio nell'Emilia (province), Emilia-Romagna" },
  { value: "MO", label: "Modena (province), Emilia-Romagna" },
  { value: "BO", label: "Bologna (province), Emilia-Romagna" },
  { value: "FE", label: "Ferrara (province), Emilia-Romagna" },
  { value: "RA", label: "Ravenna (province), Emilia-Romagna" },
  { value: "FC", label: "Forlì-Cesena (province), Emilia-Romagna" },
  { value: "RN", label: "Rimini (province), Emilia-Romagna" },
  { value: "MS", label: "Massa-Carrara (province), Toscana" },
  { value: "LU", label: "Lucca (province), Toscana" },
  { value: "PT", label: "Pistoia (province), Toscana" },
  { value: "FI", label: "Firenze (province), Toscana" },
  { value: "LI", label: "Livorno (province), Toscana" },
  { value: "PI", label: "Pisa (province), Toscana" },
  { value: "AR", label: "Arezzo (province), Toscana" },
  { value: "SI", label: "Siena (province), Toscana" },
  { value: "GR", label: "Grosseto (province), Toscana" },
  { value: "PO", label: "Prato (province), Toscana" },
  { value: "PG", label: "Perugia (province), Umbria" },
  { value: "TR", label: "Terni (province), Umbria" },
  { value: "PU", label: "Pesaro e Urbino (province), Marche" },
  { value: "AN", label: "Ancona (province), Marche" },
  { value: "MC", label: "Macerata (province), Marche" },
  { value: "AP", label: "Ascoli Piceno (province), Marche" },
  { value: "FM", label: "Fermo (province), Marche" },
  { value: "VT", label: "Viterbo (province), Lazio" },
  { value: "RI", label: "Rieti (province), Lazio" },
  { value: "RM", label: "Roma (province), Lazio" },
  { value: "LT", label: "Latina (province), Lazio" },
  { value: "FR", label: "Frosinone (province), Lazio" },
  { value: "AQ", label: "L'Aquila (province), Abruzzo" },
  { value: "TE", label: "Teramo (province), Abruzzo" },
  { value: "PE", label: "Pescara (province), Abruzzo" },
  { value: "CH", label: "Chieti (province), Abruzzo" },
  { value: "CB", label: "Campobasso (province), Molise" },
  { value: "IS", label: "Isernia (province), Molise" },
  { value: "CE", label: "Caserta (province), Campania" },
  { value: "BN", label: "Benevento (province), Campania" },
  { value: "NA", label: "Napoli (province), Campania" },
  { value: "AV", label: "Avellino (province), Campania" },
  { value: "SA", label: "Salerno (province), Campania" },
  { value: "FG", label: "Foggia (province), Puglia" },
  { value: "BA", label: "Bari (province), Puglia" },
  { value: "TA", label: "Taranto (province), Puglia" },
  { value: "BR", label: "Brindisi (province), Puglia" },
  { value: "LE", label: "Lecce (province), Puglia" },
  { value: "BT", label: "Barletta-Andria-Trani (province), Puglia" },
  { value: "PZ", label: "Potenza (province), Basilicata" },
  { value: "MT", label: "Matera (province), Basilicata" },
  { value: "CS", label: "Cosenza (province), Calabria" },
  { value: "CZ", label: "Catanzaro (province), Calabria" },
  { value: "RC", label: "Reggio di Calabria (province), Calabria" },
  { value: "KR", label: "Crotone (province), Calabria" },
  { value: "VV", label: "Vibo Valentia (province), Calabria" },
  { value: "TP", label: "Trapani (province), Sicilia" },
  { value: "PA", label: "Palermo (province), Sicilia" },
  { value: "ME", label: "Messina (province), Sicilia" },
  { value: "AG", label: "Agrigento (province), Sicilia" },
  { value: "CL", label: "Caltanissetta (province), Sicilia" },
  { value: "EN", label: "Enna (province), Sicilia" },
  { value: "CT", label: "Catania (province), Sicilia" },
  { value: "RG", label: "Ragusa (province), Sicilia" },
  { value: "SR", label: "Siracusa (province), Sicilia" },
  { value: "SS", label: "Sassari (province), Sardegna" },
  { value: "NU", label: "Nuoro (province), Sardegna" },
  { value: "CA", label: "Cagliari (province), Sardegna" },
  { value: "OR", label: "Oristano (province), Sardegna" },
  { value: "OT", label: "Olbia-Tempio (province), Sardegna" },
  { value: "OG", label: "Ogliastra (province), Sardegna" },
  { value: "VS", label: "Medio Campidano (province), Sardegna" },
  { value: "CI", label: "Carbonia-Iglesias (province), Sardegna" },
];

export const US_STATES = [
  { value: "-", label: "select state", isDisabled: true },
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AS", label: "American Samoa" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District Of Columbia" },
  { value: "FM", label: "Federated States Of Micronesia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "GU", label: "Guam" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MH", label: "Marshall Islands" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "MP", label: "Northern Mariana Islands" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PW", label: "Palau" },
  { value: "PA", label: "Pennsylvania" },
  { value: "PR", label: "Puerto Rico" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VI", label: "Virgin Islands" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];

export const ACCOUNT_TYPE_CHOICES = [
  { value: "-", label: "select account type", isDisabled: true },
  {value: "CURRENT", label: "Savings/General Account"},
  {value: "SAVINGS", label: "Savings Account"},
  {value: "CHECKING", label: "Checking Account"},
  {value: "DEPOSIT", label: "Deposit Account"},
  {value: "BUSINESS", label: "Business Account"},
]

export const LEGAL_TYPE_CHOICES = [
  { value: "-", label: "select legal type", isDisabled: true },
  {value: "BUSINESS", label: "Business Account"},
  {value: "PRIVATE", label: "Private Account"},
]

export const LEGAL_TYPE_CHOICES_ONLY_BUSINESS = [  
  {value: "BUSINESS", label: "Business Account"},
]

export const COUNTRIES_WITH_LIMITED_LEGAL_TYPE_CHOICES_BY_CURRENCY = {
  br: {
    'BRL': LEGAL_TYPE_CHOICES_ONLY_BUSINESS,
    'USD': LEGAL_TYPE_CHOICES,
  }
}

export const COUNTRIES_WITH_BANK_CODE_DROPDOWN = {
  br: [
    {value: "-", label: "Please choose recipient's bank", isDisabled: true },
    {value: "33930368", label: "7TRUST FINANCE & TAX ASSET [33930368]"},
    {value: "24313102", label: "99 PAY IP S.A. [24313102]"},
    {value: "33330067", label: "A BANK [33330067]"},
    {value: "35534511", label: "A27 IP S/A [35534511]"},
    {value: "48756121", label: "A55 SCD S.A. [574]"},
    {value: "37715993", label: "ACCREDITO SCD S.A. [406]"},
    {value: "13140088", label: "ACESSO IP S.A. [332]"},
    {value: "10868663", label: "ACG IP S.A. [10868663]"},
    {value: "20520298", label: "ADIQ [20520298]"},
    {value: "14796606", label: "ADYEN DO BRASIL IP LTDA. [14796606]"},
    {value: "18639407", label: "AGILE [18639407]"},
    {value: "07398335", label: "AILOG IP LTDA. [07398335]"},
    {value: "27214112", label: "AL5 S.A. CFI [349]"},
    {value: "32246162", label: "ALIPAY [32246162]"},
    {value: "51414521", label: "ALL IN CRED SCD S.A. [572]"},
    {value: "32778350", label: "AME DIGITAL BRASIL IP LTDA. [32778350]"},
    {value: "22443203", label: "AN SPACE PAY [22443203]"},
    {value: "00655522", label: "APE POUPEX [00655522]"},
    {value: "37168145", label: "APROMS NET IP LTDA. [37168145]"},
    {value: "16876258", label: "APTARE [16876258]"},
    {value: "00377239", label: "AQBANK [00377239]"},
    {value: "48703388", label: "ASA SCD S.A. [594]"},
    {value: "19540550", label: "ASAAS IP S.A. [461]"},
    {value: "34006497", label: "ASTROPAY [34006497]"},
    {value: "44728700", label: "ATF SCD S.A. [513]"},
    {value: "44478623", label: "ATICCA SCD S.A. [527]"},
    {value: "18684408", label: "AZIMUT BRASIL DTVM LTDA [562]"},
    {value: "00556603", label: "BANCO BARI S.A. [330]"},
    {value: "30306294", label: "BANCO BTG PACTUAL S.A. [208]"},
    {value: "27098060", label: "BANCO DIGIO [335]"},
    {value: "45246410", label: "BANCO GENIAL [125]"},
    {value: "04866275", label: "BANCO INBURSA [012]"},
    {value: "00416968", label: "BANCO INTER [077]"},
    {value: "33923798", label: "BANCO MASTER [243]"},
    {value: "92894922", label: "BANCO ORIGINAL [212]"},
    {value: "59285411", label: "BANCO PAN [623]"},
    {value: "11476673", label: "BANCO RANDON S.A. [088]"},
    {value: "00795423", label: "BANCO SEMEAR [743]"},
    {value: "02038232", label: "BANCO SICOOB S.A. [756]"},
    {value: "07679404", label: "BANCO TOPÁZIO S.A. [082]"},
    {value: "11703662", label: "BANCO TRAVELEX S.A. [095]"},
    {value: "61024352", label: "BANCO VOITER [653]"},
    {value: "78626983", label: "BANCO VR S.A. [610]"},
    {value: "15320615", label: "BANCO ÚTIL [15320615]"},
    {value: "32053736", label: "BANKOSO INSTITUICAO DE PAGAMEN [32053736]"},
    {value: "34837066", label: "BANKROW [34837066]"},
    {value: "30723871", label: "BANQI [30723871]"},
    {value: "92934215", label: "BANRISUL S.A. IP [041]"},
    {value: "28195667", label: "BCO ABC BRASIL S.A. [246]"},
    {value: "04814563", label: "BCO AFINZ S.A. - BM [299]"},
    {value: "10664513", label: "BCO AGIBANK S.A. [121]"},
    {value: "54403563", label: "BCO ARBI S.A. [213]"},
    {value: "00997185", label: "BCO B3 S.A. [096]"},
    {value: "28127603", label: "BCO BANESTES S.A. [021]"},
    {value: "58497702", label: "BCO BLUEBANK S.A. [630]"},
    {value: "61186680", label: "BCO BMG S.A. [318]"},
    {value: "01522368", label: "BCO BNP PARIBAS BRASIL S A [752]"},
    {value: "60746948", label: "BCO BRADESCO S.A. [237]"},
    {value: "01852137", label: "BCO BRASILEIRO DE CRÉDITO S.A. [378]"},
    {value: "71027866", label: "BCO BS2 S.A. [218]"},
    {value: "01858774", label: "BCO BV S.A. [413]"},
    {value: "31872495", label: "BCO C6 S.A. [336]"},
    {value: "33479023", label: "BCO CITIBANK S.A. [745]"},
    {value: "01181521", label: "BCO COOPERATIVO SICREDI S.A. [748]"},
    {value: "61033106", label: "BCO CREFISA S.A. [069]"},
    {value: "08357240", label: "BCO CSF S.A. [368]"},
    {value: "04902979", label: "BCO DA AMAZONIA S.A. [003]"},
    {value: "62232889", label: "BCO DAYCOVAL S.A [707]"},
    {value: "00000000", label: "BCO DO BRASIL S.A. [001]"},
    {value: "13009717", label: "BCO DO EST. DE SE S.A. [047]"},
    {value: "04913711", label: "BCO DO EST. DO PA S.A. [037]"},
    {value: "92702067", label: "BCO DO ESTADO DO RS S.A. [041]"},
    {value: "07237373", label: "BCO DO NORDESTE DO BRASIL S.A. [004]"},
    {value: "58616418", label: "BCO FIBRA S.A. [224]"},
    {value: "31880826", label: "BCO GUANABARA S.A. [612]"},
    {value: "53518684", label: "BCO HSBC S.A. [269]"},
    {value: "31895683", label: "BCO INDUSTRIAL DO BRASIL S.A. [604]"},
    {value: "17192451", label: "BCO ITAUCARD S.A. [17192451]"},
    {value: "33172537", label: "BCO J.P. MORGAN S.A. [376]"},
    {value: "02318507", label: "BCO KEB HANA DO BRASIL S.A. [757]"},
    {value: "59118133", label: "BCO LUSO BRASILEIRO S.A. [600]"},
    {value: "17184037", label: "BCO MERCANTIL DO BRASIL S.A. [389]"},
    {value: "61820817", label: "BCO PAULISTA S.A. [611]"},
    {value: "68900810", label: "BCO RENDIMENTO S.A. [633]"},
    {value: "00517645", label: "BCO RIBEIRAO PRETO S.A. [741]"},
    {value: "58160789", label: "BCO SAFRA S.A. [422]"},
    {value: "90400888", label: "BCO SANTANDER (BRASIL) S.A [033]"},
    {value: "11970623", label: "BCO SENFF S.A. [276]"},
    {value: "60889128", label: "BCO SOFISA S.A. [637]"},
    {value: "17351180", label: "BCO TRIANGULO S.A. [634]"},
    {value: "59588111", label: "BCO VOTORANTIM S.A. [655]"},
    {value: "13720915", label: "BCO WESTERN UNION [119]"},
    {value: "33264668", label: "BCO XP S.A. [348]"},
    {value: "35523352", label: "BEES IP LTDA. [35523352]"},
    {value: "32074986", label: "BEETELLER [550]"},
    {value: "25238191", label: "BELLUNO IP LTDA. [25238191]"},
    {value: "40910463", label: "BIPA INSTITUICAO DE PAGAMENTO [40910463]"},
    {value: "35136120", label: "BITSO IP LTDA [35136120]"},
    {value: "12481100", label: "BIZ IP LTDA. [12481100]"},
    {value: "16814330", label: "BK IP S.A. [690]"},
    {value: "10506341", label: "BLU IP LTDA. [10506341]"},
    {value: "04838403", label: "BLU PAY [04838403]"},
    {value: "13372874", label: "BMB PAGAMENTOS [13372874]"},
    {value: "34337707", label: "BMP SCD S.A. [531]"},
    {value: "11581339", label: "BMP SCMEPP LTDA [274]"},
    {value: "17826860", label: "BMS SCD S.A. [377]"},
    {value: "45331622", label: "BNK DIGITAL SCD S.A. [547]"},
    {value: "62073200", label: "BOFA MERRILL LYNCH BM S.A. [755]"},
    {value: "36586946", label: "BONUSPAGO SCD S.A. [408]"},
    {value: "27842177", label: "BPY CCTVM S.A. [271]"},
    {value: "03130170", label: "BRASIL CARD IP LTDA [03130170]"},
    {value: "30507541", label: "BRASIL CASH IP S.A. [30507541]"},
    {value: "00000208", label: "BRB - BCO DE BRASILIA S.A. [070]"},
    {value: "49933388", label: "BRCONDOS SCD S.A. [568]"},
    {value: "09437293", label: "BRINKS PAY IP LTDA. [09437293]"},
    {value: "24722685", label: "BRX BANK IP [24722685]"},
    {value: "40994589", label: "BSCASH [40994589]"},
    {value: "25528753", label: "C.C CREDIVERDE [25528753]"},
    {value: "32345784", label: "C6 CTVM LTDA. [32345784]"},
    {value: "00360305", label: "CAIXA ECONOMICA FEDERAL [104]"},
    {value: "40083667", label: "CAPITAL CONSIG SCD S.A. [465]"},
    {value: "13966572", label: "CAPPTA IP S.A. [13966572]"},
    {value: "08512761", label: "CARDPAY [08512761]"},
    {value: "21332862", label: "CARTOS SCD S.A. [324]"},
    {value: "33207641", label: "CARTWAVE [33207641]"},
    {value: "09313766", label: "CARUANA SCFI [130]"},
    {value: "05442029", label: "CASA CREDITO S.A. SCM [159]"},
    {value: "34615822", label: "CASHWAY TECNOLOGIA DA INFORMAC [34615822]"},
    {value: "42873828", label: "CC AGROCREDI LTDA [42873828]"},
    {value: "25387671", label: "CC ALTO PARANAIBA E REGIÃO [25387671]"},
    {value: "00068987", label: "CC ARACREDI LTDA. [00068987]"},
    {value: "03047549", label: "CC CAP UNICIDADES [03047549]"},
    {value: "41753500", label: "CC CARLOS CHAGAS [41753500]"},
    {value: "54401286", label: "CC COCRE [54401286]"},
    {value: "65229254", label: "CC COOPACREDI [65229254]"},
    {value: "53623781", label: "CC COOPCRED [53623781]"},
    {value: "87779625", label: "CC COOPERAÇÃO - SICREDI COOPERAÇÃO [87779625]"},
    {value: "49389307", label: "CC COOPLIVRE [49389307]"},
    {value: "18966739", label: "CC COPERSUL LTDA [18966739]"},
    {value: "19449602", label: "CC CREDCOOPER LTDA [19449602]"},
    {value: "00429890", label: "CC CREDIAGRO [00429890]"},
    {value: "25353939", label: "CC CREDIALP [25353939]"},
    {value: "66398496", label: "CC CREDIARA LTDA. [66398496]"},
    {value: "66259110", label: "CC CREDIBAM LTDA. [66259110]"},
    {value: "21670187", label: "CC CREDIBOM [21670187]"},
    {value: "25395435", label: "CC CREDICAF LTDA [25395435]"},
    {value: "01609345", label: "CC CREDICAMPINA [01609345]"},
    {value: "21661202", label: "CC CREDICAMPO LTDA [21661202]"},
    {value: "00804046", label: "CC CREDICAPI - SICOOB CREDICAPI [00804046]"},
    {value: "23949522", label: "CC CREDICARPA [23949522]"},
    {value: "00966246", label: "CC CREDICERIPA [00966246]"},
    {value: "54037916", label: "CC CREDICITRUS [54037916]"},
    {value: "38588174", label: "CC CREDICOPE [756]"},
    {value: "07469260", label: "CC CREDIFIEMG [07469260]"},
    {value: "41931445", label: "CC CREDIFOR LTDA [41931445]"},
    {value: "71243034", label: "CC CREDIJEQUITINHONHA LTDA [71243034]"},
    {value: "64480833", label: "CC CREDIMAC LTDA - SICOOB CREDIMAC [64480833]"},
    {value: "01152097", label: "CC CREDIMATA [01152097]"},
    {value: "21866694", label: "CC CREDINOR [21866694]"},
    {value: "64276058", label: "CC CREDINORTE - SICOOB CREDINORTE [64276058]"},
    {value: "06324872", label: "CC CREDINOSSO [06324872]"},
    {value: "24048910", label: "CC CREDINTER [24048910]"},
    {value: "42934794", label: "CC CREDIPIMENTA [42934794]"},
    {value: "03412878", label: "CC CREDIRAMA [03412878]"},
    {value: "22753982", label: "CC CREDISETE LTDA [22753982]"},
    {value: "03645752", label: "CC CREDISG [03645752]"},
    {value: "22656789", label: "CC CREDISUDESTE LTDA [22656789]"},
    {value: "64237530", label: "CC CREDIUNA LTDA [64237530]"},
    {value: "25798596", label: "CC CREDIVAR [25798596]"},
    {value: "00803287", label: "CC CREDIVAZ LTDA [00803287]"},
    {value: "22724710", label: "CC CREDIVERTENTES [22724710]"},
    {value: "05463934", label: "CC CREDLIDER [05463934]"},
    {value: "25536764", label: "CC CREDPLUS [25536764]"},
    {value: "09512539", label: "CC DA FOZ DO RIO ITAJAÍ AÇU [09512539]"},
    {value: "09590601", label: "CC DA SERRA CATARINENSE [09590601]"},
    {value: "04247370", label: "CC DE EMPRESÁRIOS [04247370]"},
    {value: "01187961", label: "CC DISTRITO FEDERAL E ENTORNO [01187961]"},
    {value: "03461243", label: "CC DO NORTE CATARINENSE [03461243]"},
    {value: "03033469", label: "CC DO PLANALTO SUL [03033469]"},
    {value: "10808037", label: "CC EMPRESÁRIOS DE MANAUS [10808037]"},
    {value: "26014175", label: "CC GUARANICREDI [26014175]"},
    {value: "04751713", label: "CC IN DE RONDÔNIA - SICOOB CREDJURD [04751713]"},
    {value: "07122321", label: "CC INTEGRADO - SICOOB INTEGRADO [07122321]"},
    {value: "08044854", label: "CC INVESTIMENTO SICOOB CENTRO [08044854]"},
    {value: "08844074", label: "CC ITAPETININGA - SICOOB CRED-ACI [08844074]"},
    {value: "09552111", label: "CC JUST GOIAS E CELG [09552111]"},
    {value: "39343350", label: "CC LAR CREDI [421]"},
    {value: "88530142", label: "CC LIBERDADE - SICREDI LIBERDADE [88530142]"},
    {value: "14913919", label: "CC MERCADO IMOB - SICOOB IMOB.VC [14913919]"},
    {value: "05477038", label: "CC NO PIAUÍ - SICOOB PIAUÍ [05477038]"},
    {value: "00698609", label: "CC NORTE E NOROESTE DE MINAS GERAIS [00698609]"},
    {value: "03419786", label: "CC NOSSA SENHORA DO DESTERRO [03419786]"},
    {value: "59869560", label: "CC NOSSO - SICOOB NOSSO [59869560]"},
    {value: "22760839", label: "CC NOSSOCREDITO [22760839]"},
    {value: "03519240", label: "CC PODER JUD E MP MG [03519240]"},
    {value: "22749014", label: "CC REGIÃO CENTRAL MG [22749014]"},
    {value: "05392810", label: "CC REGIÃO MERIDIONAL BRASIL [05392810]"},
    {value: "05097757", label: "CC SERV FIN CTBA E REG [05097757]"},
    {value: "03269540", label: "CC SERV MIL POL CIVIL SEC ED [03269540]"},
    {value: "00512839", label: "CC SERV. SANTO ANDRÉ SP - CECRESA [00512839]"},
    {value: "04013172", label: "CC SICOOB 3 COLINAS [04013172]"},
    {value: "06174009", label: "CC SICOOB ALIANÇA [06174009]"},
    {value: "34148882", label: "CC SICOOB CENTRAL BA [34148882]"},
    {value: "09403026", label: "CC SICOOB CENTROLESTE [09403026]"},
    {value: "32615247", label: "CC SICOOB COOPEC LTDA. [32615247]"},
    {value: "04174720", label: "CC SICOOB COOPEMAR [04174720]"},
    {value: "62673470", label: "CC SICOOB COOPMIL [62673470]"},
    {value: "01205736", label: "CC SICOOB COSTA DO DESCOBRIMENTO [01205736]"},
    {value: "04321309", label: "CC SICOOB CRED EXECUTIVO [04321309]"},
    {value: "02528151", label: "CC SICOOB CREDCOOP [02528151]"},
    {value: "71237184", label: "CC SICOOB CREDIBELO [71237184]"},
    {value: "04529074", label: "CC SICOOB CREDICAPITAL [04529074]"},
    {value: "02282165", label: "CC SICOOB CREDICONQUISTA [02282165]"},
    {value: "41697103", label: "CC SICOOB CREDILIVRE [41697103]"},
    {value: "25420696", label: "CC SICOOB CREDINACIONAL [25420696]"},
    {value: "42880617", label: "CC SICOOB CREDITIROS [42880617]"},
    {value: "25387655", label: "CC SICOOB CREDIVALE [25387655]"},
    {value: "03535065", label: "CC SICOOB CREDMETAL [03535065]"},
    {value: "02935307", label: "CC SICOOB CREDSEGURO LTDA. [02935307]"},
    {value: "04388688", label: "CC SICOOB ENGECRED [04388688]"},
    {value: "02447120", label: "CC SICOOB EXTREMO SUL LTDA. [02447120]"},
    {value: "07194313", label: "CC SICOOB HORIZONTE [07194313]"},
    {value: "24610065", label: "CC SICOOB IPÊ [24610065]"},
    {value: "03459850", label: "CC SICOOB METROPOLITANO [03459850]"},
    {value: "02876918", label: "CC SICOOB NORTE SUL [02876918]"},
    {value: "05582619", label: "CC SICOOB OURO VERDE [05582619]"},
    {value: "02057584", label: "CC SICOOB SERTÃO [02057584]"},
    {value: "14568725", label: "CC SICOOB UNIMAIS RIO LTDA [14568725]"},
    {value: "02466552", label: "CC SICOOB VALE SUL [02466552]"},
    {value: "05545390", label: "CC SICREDI COOMAMP [05545390]"},
    {value: "01374196", label: "CC SÃO FRANCISCO DE SALES LTDA. [01374196]"},
    {value: "00075847", label: "CC UNICRED CENTRO-SUL [00075847]"},
    {value: "04355489", label: "CC UNICRED COOMARCA [04355489]"},
    {value: "01039011", label: "CC UNICRED DESBRAVADORA LTDA [01039011]"},
    {value: "01727929", label: "CC UNICRED EVOLUÇÃO LTDA. [01727929]"},
    {value: "74114042", label: "CC UNICRED UNIÃO LTDA [74114042]"},
    {value: "74064502", label: "CC UNICRED VALOR CAPITAL [74064502]"},
    {value: "26178111", label: "CC UNIÃO CENTRO OESTE LTDA [26178111]"},
    {value: "65239402", label: "CC UNIÃO DO CENTRO OESTE DE MINAS [65239402]"},
    {value: "00707903", label: "CC VALE DO CANOAS [00707903]"},
    {value: "82133182", label: "CC VALE EUROPEU - SICOOB EURO VALE [82133182]"},
    {value: "02883398", label: "CC VALE ITAJAÍ E ITAPOCÚ [02883398]"},
    {value: "32428294", label: "CCC DO ESP.SANTO - SICOOB ES [32428294]"},
    {value: "63917579", label: "CCC DO ESTADO DE SÃO PAULO [63917579]"},
    {value: "03502131", label: "CCC DO NORTE DO BRASIL [03502131]"},
    {value: "00106180", label: "CCC EST MT, MS E MUN DE CACOAL/RO [00106180]"},
    {value: "00309024", label: "CCC ESTADO MG - CECREMGE [00309024]"},
    {value: "62931522", label: "CCC ESTADO SP - CECRESP [62931522]"},
    {value: "25683434", label: "CCC MINAS GERAIS - CREDIMINAS [25683434]"},
    {value: "80160260", label: "CCC SICOOB CENTRAL SC/RS [756]"},
    {value: "05036532", label: "CCC UNICOOB-SICOOB CENTR UNIC [05036532]"},
    {value: "53841911", label: "CCI UNINDÚSTRIA [53841911]"},
    {value: "05597773", label: "CCILA DO OESTE DE RONDÔNIA [05597773]"},
    {value: "41805003", label: "CCLA ALTO SÃO FRANCISCO [41805003]"},
    {value: "33615055", label: "CCLA ANÁPOLIS E REGIÃO [33615055]"},
    {value: "00869687", label: "CCLA BOA ESPERANÇA [00869687]"},
    {value: "25743311", label: "CCLA CARMO DO RIO CLARO [25743311]"},
    {value: "37395399", label: "CCLA CENTRO BRASILEIRA LTDA. [37395399]"},
    {value: "02173447", label: "CCLA CENTRO NORDESTE MINEIRO [02173447]"},
    {value: "03326437", label: "CCLA CENTRO NORTE MT/MS [03326437]"},
    {value: "07502031", label: "CCLA CENTRO OESTE LTDA. [07502031]"},    
    {value: "33579731", label: "CCLA CENTRO-SUL GOIANO [33579731]"},
    {value: "09576849", label: "CCLA CERES E RIALMA LTDA [09576849]"},
    {value: "02232383", label: "CCLA CIRCUITO CAMPOS VERTENTES [02232383]"},
    {value: "03941182", label: "CCLA CIRCUITO DAS ÁGUAS [03941182]"},
    {value: "02338666", label: "CCLA CREDIEMBRAPA [02338666]"},
    {value: "02309070", label: "CCLA CREDISIS JICRED [097]"},
    {value: "02197569", label: "CCLA CREDSAOPAULO [02197569]"},
    {value: "10209619", label: "CCLA DA GRANDE GOIÂNIA LTDA. [10209619]"},
    {value: "11907520", label: "CCLA DA PARAÍBA - SICOOB PARAÍBA [11907520]"},
    {value: "02144899", label: "CCLA DA REGIÃO CENTRAL DE RONDÔNIA [02144899]"},
    {value: "25387713", label: "CCLA DA REGIÃO DE  PARÁ DE MINAS [25387713]"},
    {value: "53236808", label: "CCLA DE ARARAQUARA E REGIÃO [53236808]"},
    {value: "01760242", label: "CCLA DE BH E CIDADES POLO DE MG [01760242]"},
    {value: "02254376", label: "CCLA DE DORES DO INDAIA [02254376]"},
    {value: "37631058", label: "CCLA DE PALMEIRAS E REGIÃO [37631058]"},
    {value: "04181542", label: "CCLA DE PITANGUI E REGIAO LTDA [04181542]"},
    {value: "66262643", label: "CCLA DE POMPEU LTDA. [66262643]"},
    {value: "09033698", label: "CCLA DE RIO VERDE E REGIÃO [09033698]"},
    {value: "02137018", label: "CCLA DE RORAIMA LTDA. [02137018]"},
    {value: "66402207", label: "CCLA DE SÃO ROQUE DE MINAS LTDA. [66402207]"},
    {value: "10319386", label: "CCLA DO CENTRO SUL DE MS [10319386]"},
    {value: "02015588", label: "CCLA DO CENTRO SUL RONDONIENSE [02015588]"},
    {value: "01389651", label: "CCLA DO PLANALTO CATARINENSE [01389651]"},
    {value: "01692448", label: "CCLA DO PLANALTO SERRANO [01692448]"},
    {value: "03427097", label: "CCLA DO SUL CATARINENSE [03427097]"},
    {value: "26960328", label: "CCLA DO TOCANTINS [26960328]"},
    {value: "02480577", label: "CCLA E DOS ADV [02480577]"},
    {value: "83836114", label: "CCLA ESTADO DO PARÁ - SICOOB COOESA [83836114]"},
    {value: "04079285", label: "CCLA ITAJUBÁ - SICOOB SUDESTE MAIS [04079285]"},
    {value: "10143499", label: "CCLA JATAÍ E REGIÃO [10143499]"},
    {value: "01739375", label: "CCLA LAGOA DA PRATA [01739375]"},
    {value: "01559914", label: "CCLA LESTE E NORDESTE MINEIRO [01559914]"},
    {value: "14046512", label: "CCLA MARGEM ESQUERDA DO URUCUI [14046512]"},
    {value: "02031139", label: "CCLA MONTES CLAROS [02031139]"},
    {value: "01667766", label: "CCLA NOVA SERRANA E REGIÃO CO [01667766]"},
    {value: "01009908", label: "CCLA PARA DE MINAS [01009908]"},
    {value: "26178533", label: "CCLA PONTAL DO TRIANGULO [26178533]"},
    {value: "41669227", label: "CCLA PROD RURAIS TRIÂNGULO [41669227]"},
    {value: "05158093", label: "CCLA REG LESTE BACIA RIO DOCE [05158093]"},
    {value: "42887133", label: "CCLA REG SUDESTE MG [42887133]"},
    {value: "01736516", label: "CCLA REG. CTR. E OESTE MINEIRO [01736516]"},
    {value: "01699652", label: "CCLA REGIÃO GUAXUPÉ [01699652]"},
    {value: "06910457", label: "CCLA SANTA CRUZ PALMEIRAS [06910457]"},
    {value: "41707258", label: "CCLA SANTO ANTONIO DO MONTE [41707258]"},
    {value: "01657678", label: "CCLA SEBASTIAO PARAISO [01657678]"},
    {value: "21797311", label: "CCLA SERV POD LEG MG - SICOOB COFAL [21797311]"},
    {value: "07026923", label: "CCLA SICOOB ARENITO PR / SP [07026923]"},
    {value: "03102185", label: "CCLA SICOOB CENTRO NORDESTE [03102185]"},
    {value: "53935029", label: "CCLA SICOOB COOCRELIVRE [53935029]"},
    {value: "03862898", label: "CCLA SICOOB COOPERCORREIOS [03862898]"},
    {value: "25363615", label: "CCLA SICOOB COOPJUS [25363615]"},
    {value: "19875244", label: "CCLA SICOOB COPESITA [19875244]"},
    {value: "08795285", label: "CCLA SICOOB CREDIACIL [08795285]"},
    {value: "00694389", label: "CCLA SICOOB CREDICARU SC/RS [00694389]"},
    {value: "01644264", label: "CCLA SICOOB CREDIMEPI [01644264]"},
    {value: "01667352", label: "CCLA SICOOB CREDMISSÃO LTDA. [01667352]"},
    {value: "03732359", label: "CCLA SICOOB DE PERNAMBUCO [03732359]"},
    {value: "08742188", label: "CCLA SICOOB INTEGRAÇÃO [08742188]"},
    {value: "23623636", label: "CCLA SICOOB NORTE MT [23623636]"},
    {value: "09424988", label: "CCLA SICOOB OESTE MARANHENSE [09424988]"},
    {value: "02179673", label: "CCLA SICOOB OURICRED [02179673]"},
    {value: "10262276", label: "CCLA SICOOB PAULISTA [10262276]"},
    {value: "26526166", label: "CCLA SICOOB SUL MARANHENSE [26526166]"},
    {value: "00259231", label: "CCLA SICOOB UNIMAIS METROPOLITANA [00259231]"},
    {value: "07946216", label: "CCLA SICOOB UNIÃO SUDESTE [07946216]"},
    {value: "02090126", label: "CCLA SICOOB VALCREDI SUL [02090126]"},
    {value: "24795049", label: "CCLA SUDOESTE GOIANO [24795049]"},
    {value: "01604998", label: "CCLA SUL MINAS-SICOOB CREDIVAS [01604998]"},
    {value: "07789195", label: "CCLA TRANSPORT RODOV VEICULOS [07789195]"},
    {value: "04876393", label: "CCLA TRÊS FRONTEIRAS [04876393]"},
    {value: "01703620", label: "CCLA UNIÃO CENTRO OESTE MINAS [01703620]"},
    {value: "01060307", label: "CCLA UNIÃO VALES DO PIRANGA, MATIPÓ [01060307]"},
    {value: "02587492", label: "CCLA URUBICI [02587492]"},
    {value: "24830879", label: "CCLA VALE DO ARAGUAIA [24830879]"},
    {value: "19869338", label: "CCLA VALE DO AÇO [19869338]"},
    {value: "25404542", label: "CCLA VALE DO GORUTUBA [25404542]"},
    {value: "01637949", label: "CCLA VALE DO PARANAPANEMA [01637949]"},
    {value: "24799033", label: "CCLA VALE DO PARANAÍBA [24799033]"},
    {value: "25683475", label: "CCLA VALE DO RIO GRANDE [25683475]"},
    {value: "00968602", label: "CCLA VALE SÃO PATRICIO LTDA [00968602]"},
    {value: "02335109", label: "CCLA ZONA DA MATA LTDA [02335109]"},
    {value: "12384953", label: "CCLAA JARAGUÁ DO SUL E REGIÃO [12384953]"},
    {value: "02641969", label: "CCLAA NOVA TRENTO [02641969]"},
    {value: "08030602", label: "CCM CORRET SEG EST SAO PAULO [08030602]"},
    {value: "04715685", label: "CCM DESP TRÂNS SC E RS [016]"},
    {value: "04414354", label: "CCM DO ABC - COOPER 7 [04414354]"},
    {value: "03620772", label: "CCM DO CEARÁ - SICOOB CEARÁ [03620772]"},
    {value: "05861932", label: "CCM DOS ADVOGADOS DE SC [05861932]"},
    {value: "02093154", label: "CCM EMPR MAGAZINE LUIZA [02093154]"},
    {value: "36900256", label: "CCM MED EMP MT [36900256]"},
    {value: "74248949", label: "CCM SERV MUN S JOAO BOA VISTA [74248949]"},
    {value: "03612679", label: "CCM SERV PUBLICOS - CREDI SP [03612679]"},
    {value: "02275781", label: "CCM SICOOB COOPERCRET [02275781]"},
    {value: "07669921", label: "CCM SICOOB CREDIACISC [07669921]"},
    {value: "10175348", label: "CCMLA SOROCABA [10175348]"},
    {value: "05969937", label: "CCMS MUNICIPAIS DE BEBEDOURO [05969937]"},
    {value: "76461557", label: "CCR COOPAVEL [281]"},
    {value: "44373041", label: "CCR CREDICANA [44373041]"},
    {value: "01073966", label: "CCR DE ABELARDO LUZ [322]"},
    {value: "32422628", label: "CCR DE GUACUI [32422628]"},
    {value: "08240446", label: "CCR DE IBIAM [391]"},
    {value: "08482873", label: "CCR DO AGRESTE ALAGOANO [673]"},
    {value: "53776852", label: "CCR FOR CANA CENTRO EST SP [53776852]"},
    {value: "00204963", label: "CCR SEARA [430]"},
    {value: "18394228", label: "CDC SCD S.A. [470]"},
    {value: "20062766", label: "CECM COL GRUPO EMPR A COSTA [20062766]"},
    {value: "05667301", label: "CECM COOPERSERV [05667301]"},
    {value: "97259253", label: "CECM CREDISIS/CREDIPLAN [97259253]"},
    {value: "01062439", label: "CECM DOS FUNCIONARIOS DA COMIGO [01062439]"},
    {value: "03844699", label: "CECM DOS TRAB.PORT. DA G.VITOR [385]"},
    {value: "09579249", label: "CECM EMP AMERICANA, LIMEIRA E [09579249]"},
    {value: "03674133", label: "CECM EMP INST SF SÃO PAULO CAM [03674133]"},
    {value: "08850613", label: "CECM EMPR CENT ELÉTRICAS/SC [08850613]"},
    {value: "58022195", label: "CECM EMPR EMP ZILLO LORENZETTI [58022195]"},
    {value: "19402130", label: "CECM EMPR EST HOSP BH RM ZM [19402130]"},
    {value: "04694278", label: "CECM INTEG. MF DP ESTADO RJ [04694278]"},
    {value: "51489318", label: "CECM MAGISTRADOS DE SÃO PAULO [51489318]"},
    {value: "04572960", label: "CECM MILITARES ESTADUAIS DE SC [04572960]"},
    {value: "07714057", label: "CECM PROF ÁREA NOTARIAL REGISTRAL [07714057]"},
    {value: "16651002", label: "CECM SERV MUN ITABIRA [16651002]"},
    {value: "41791005", label: "CECM SERV MUN POÇOS DE CALDAS [41791005]"},
    {value: "04152107", label: "CECM SERV POL MIL SP REGIÃO CE [04152107]"},
    {value: "08071414", label: "CECM SICOOB COOPERAC [08071414]"},
    {value: "16564240", label: "CECM SICOOB COOPERNAPI [16564240]"},
    {value: "09004796", label: "CECM SICOOB CRED-ACILPA [09004796]"},
    {value: "20961629", label: "CECM SICOOB CREDIVALE [20961629]"},
    {value: "02072790", label: "CECM SICOOB CREDSAÚDE [02072790]"},
    {value: "04833655", label: "CECM SICOOB METALCRED [04833655]"},
    {value: "30949267", label: "CECME CHOCOLATES GAROTO LTDA [30949267]"},
    {value: "57563728", label: "CECME EMPR EMP GR ECON RHODIA [57563728]"},
    {value: "04243780", label: "CENTRAL SICOOB UNI DE CC [04243780]"},
    {value: "38406148", label: "CF BANK [38406148]"},
    {value: "04663561", label: "CI INT SOL VALE DAS ÁGUAS PR/MG [04663561]"},
    {value: "35257964", label: "CICLLOS PAY [35257964]"},
    {value: "01027058", label: "CIELO IP S.A. [362]"},
    {value: "10218474", label: "CIVIA COOP CRED [10218474]"},
    {value: "73326449", label: "CLA SICOOB CRUZ ALTA LTDA [73326449]"},
    {value: "41538335", label: "CLARA IP [41538335]"},
    {value: "34878543", label: "CLARO PAY S.A. IP [34878543]"},
    {value: "18189547", label: "CLOUDWALK IP LTDA [542]"},
    {value: "36947229", label: "COBUCCIO S.A. SCFI [402]"},
    {value: "26721922", label: "CODEPAY [26721922]"},
    {value: "31531997", label: "CONPAY IP S.A. [31531997]"},
    {value: "12473687", label: "CONTA PRONTA IP [569]"},
    {value: "47381104", label: "CONTAAZUL [47381104]"},
    {value: "07318874", label: "COOP SICOOB MÉDIO OESTE [07318874]"},
    {value: "02923389", label: "COOP SICREDI SERIGY [02923389]"},
    {value: "03320525", label: "COOP ARACOOP LTDA. - SICOOB ARACOOP [03320525]"},
    {value: "02282709", label: "COOP CENTRO NORTE BRASILEIRO [02282709]"},
    {value: "01658426", label: "COOP COOPERFORTE LTDA. [379]"},
    {value: "05491616", label: "COOP CREDITAG [400]"},
    {value: "04831810", label: "COOP CRESERV CREDISIS [471]"},
    {value: "07412987", label: "COOP CRESOL ALIANÇA [07412987]"},
    {value: "07215632", label: "COOP CRESOL ALTERNATIVA [07215632]"},
    {value: "07465539", label: "COOP CRESOL ALTO VALE [07465539]"},
    {value: "10520232", label: "COOP CRESOL AMAZONIA [10520232]"},
    {value: "04565791", label: "COOP CRESOL ARATIBA [04565791]"},
    {value: "07946451", label: "COOP CRESOL ATIVA [07946451]"},
    {value: "05211129", label: "COOP CRESOL CENTRO NORTE [05211129]"},
    {value: "01155801", label: "COOP CRESOL CENTRO SERRA [01155801]"},
    {value: "02910987", label: "COOP CRESOL CENTRO SUL RS/MS [02910987]"},
    {value: "11969853", label: "COOP CRESOL CONEXÃO [11969853]"},
    {value: "07252614", label: "COOP CRESOL CONFIANÇA [07252614]"},
    {value: "09488496", label: "COOP CRESOL COOPERACRED [09488496]"},
    {value: "05983995", label: "COOP CRESOL COOPERAR [05983995]"},
    {value: "05425526", label: "COOP CRESOL DESENVOLVIMENTO [05425526]"},
    {value: "03485130", label: "COOP CRESOL ENCOSTAS DA SERRA GERAL [03485130]"},
    {value: "06031727", label: "COOP CRESOL ESSENCIA [06031727]"},
    {value: "02844024", label: "COOP CRESOL EVOLUÇAO [02844024]"},
    {value: "05276770", label: "COOP CRESOL FRONTEIRAS PR/SC/SP/ES [05276770]"},
    {value: "05241145", label: "COOP CRESOL GETULIO VARGAS [05241145]"},
    {value: "04490531", label: "COOP CRESOL GOIAS [04490531]"},
    {value: "06126780", label: "COOP CRESOL GRANDES LAGOS PR/SP [06126780]"},
    {value: "05277312", label: "COOP CRESOL HORIZONTE [05277312]"},
    {value: "05070112", label: "COOP CRESOL INOVAÇAO [05070112]"},
    {value: "07268499", label: "COOP CRESOL INTEGRACAO [07268499]"},
    {value: "08055016", label: "COOP CRESOL INTERAÇÃO [08055016]"},
    {value: "09463721", label: "COOP CRESOL JACINTO MACHADO [09463721]"},
    {value: "02904125", label: "COOP CRESOL JACUTINGA [02904125]"},
    {value: "02934201", label: "COOP CRESOL LIDERANCA [02934201]"},
    {value: "05410056", label: "COOP CRESOL LITORAL [05410056]"},
    {value: "05269976", label: "COOP CRESOL MAIS [05269976]"},
    {value: "50735161", label: "COOP CRESOL MATO GROSSO [50735161]"},
    {value: "08624548", label: "COOP CRESOL MINAS GERAIS [133]"},
    {value: "08488377", label: "COOP CRESOL MISSÕES FRONTEIRA RS [08488377]"},
    {value: "05494591", label: "COOP CRESOL NASCENTE [05494591]"},
    {value: "02663426", label: "COOP CRESOL NOROESTE [02663426]"},
    {value: "07925729", label: "COOP CRESOL NORTE PARANAENSE [07925729]"},
    {value: "05220243", label: "COOP CRESOL ORIGENS [05220243]"},
    {value: "00971300", label: "COOP CRESOL PIONEIRA [00971300]"},
    {value: "05863726", label: "COOP CRESOL PLANALTO SERRA [05863726]"},
    {value: "02766672", label: "COOP CRESOL PLANALTO SUL [02766672]"},
    {value: "53575491", label: "COOP CRESOL PRIMATO CREDI [53575491]"},
    {value: "02448310", label: "COOP CRESOL PROGRESSO [02448310]"},
    {value: "17343510", label: "COOP CRESOL RAIZ [17343510]"},
    {value: "06139650", label: "COOP CRESOL RIO GRANDE DO SUL [06139650]"},
    {value: "03015152", label: "COOP CRESOL SÃO VALENTIM [03015152]"},
    {value: "04350225", label: "COOP CRESOL TRADICAO [04350225]"},
    {value: "24431221", label: "COOP CRESOL TRANSAMAZÔNICA [24431221]"},
    {value: "04261151", label: "COOP CRESOL TRANSFORMAÇÃO [04261151]"},
    {value: "09330158", label: "COOP CRESOL TREZE DE MAIO [09330158]"},
    {value: "08560508", label: "COOP CRESOL TRIUNFO [08560508]"},
    {value: "05231945", label: "COOP CRESOL UNIAO DOS VALES [05231945]"},
    {value: "02446089", label: "COOP CRESOL UNIAO [02446089]"},
    {value: "07512780", label: "COOP CRESOL VALE EUROPEU [07512780]"},
    {value: "07320890", label: "COOP CRESOL VALE [07320890]"},
    {value: "03965737", label: "COOP CRESOL VANGUARDA [03965737]"},
    {value: "07509426", label: "COOP CRESOL XANXERE [07509426]"},
    {value: "02904138", label: "COOP CRESOL ÁUREA [02904138]"},
    {value: "04406371", label: "COOP DO ESTADO DE GOIÁS [04406371]"},
    {value: "01608685", label: "COOP DO ESTADO DO ACRE LTDA. [01608685]"},
    {value: "10311218", label: "COOP EVOLUA [10311218]"},
    {value: "03612764", label: "COOP FRONTEIRAS [03612764]"},
    {value: "03000142", label: "COOP POL FED - SICREDI POL [03000142]"},
    {value: "05247312", label: "COOP SICOOB BURITIS [05247312]"},
    {value: "05222094", label: "COOP SICOOB CERRADO [05222094]"},
    {value: "07097064", label: "COOP SICOOB CONFIANÇA [07097064]"},
    {value: "46642294", label: "COOP SICOOB COOPEREMB [46642294]"},
    {value: "03603683", label: "COOP SICOOB COOPERPLAN CREDSEF [03603683]"},
    {value: "37079720", label: "COOP SICOOB CREDIJUSTRA [37079720]"},
    {value: "02217068", label: "COOP SICOOB CREDITABIL [02217068]"},
    {value: "00694877", label: "COOP SICOOB EXECUTIVO LTDA. [00694877]"},
    {value: "05241619", label: "COOP SICOOB PRIMAVERA [05241619]"},
    {value: "44469161", label: "COOP SICOOB PRO [44469161]"},
    {value: "37554441", label: "COOP SICOOB UNI SUL MS [37554441]"},
    {value: "03750034", label: "COOP SICREDI AJURIS [03750034]"},
    {value: "04484490", label: "COOP SICREDI ALTA NOROESTE SP [04484490]"},
    {value: "09343038", label: "COOP SICREDI ALTSERTÃO PARAIBANO [09343038]"},
    {value: "33021064", label: "COOP SICREDI ARAXINGU [33021064]"},
    {value: "04853988", label: "COOP SICREDI BANDEIRANTES [04853988]"},
    {value: "33022690", label: "COOP SICREDI BIOMAS [33022690]"},
    {value: "03042597", label: "COOP SICREDI CAMPO GRANDE [03042597]"},
    {value: "26555235", label: "COOP SICREDI CELEIRO DO MT [26555235]"},
    {value: "03566655", label: "COOP SICREDI CELEIRO OESTE [03566655]"},
    {value: "04463602", label: "COOP SICREDI CEN OEST PAULISTA [04463602]"},
    {value: "41255225", label: "COOP SICREDI CENTRO PERNAMBUCANA [41255225]"},
    {value: "26408161", label: "COOP SICREDI CENTRO-SUL MS/BA [26408161]"},
    {value: "06332931", label: "COOP SICREDI CERRADO GO [06332931]"},
    {value: "19962468", label: "COOP SICREDI COOABCRED RS [19962468]"},
    {value: "08041950", label: "COOP SICREDI COOPERJURIS [08041950]"},
    {value: "06078926", label: "COOP SICREDI CREDENOREG [06078926]"},
    {value: "04886317", label: "COOP SICREDI CREDJURIS [04886317]"},
    {value: "04525997", label: "COOP SICREDI EDUCAÇÃO RS [04525997]"},
    {value: "07070495", label: "COOP SICREDI EMPREENDEDORES [07070495]"},
    {value: "35571249", label: "COOP SICREDI EVOLUÇÃO [35571249]"},
    {value: "41180092", label: "COOP SICREDI EXPANSÃO [41180092]"},
    {value: "57647653", label: "COOP SICREDI FORÇA DOS VENTOS [57647653]"},
    {value: "37442605", label: "COOP SICREDI GRANDES RIOS [37442605]"},
    {value: "26549311", label: "COOP SICREDI INTEGRAÇÃO MT/AP/PA [26549311]"},
    {value: "02924977", label: "COOP SICREDI MEDICRED [02924977]"},
    {value: "03662047", label: "COOP SICREDI MP [03662047]"},
    {value: "03065046", label: "COOP SICREDI NOROESTE SP [03065046]"},
    {value: "02843443", label: "COOP SICREDI NORTE SC [748]"},
    {value: "26529420", label: "COOP SICREDI OURO VERDE MT [26529420]"},
    {value: "26408187", label: "COOP SICREDI PANTANAL [26408187]"},
    {value: "10736214", label: "COOP SICREDI PLAN CENTRAL [10736214]"},
    {value: "32995755", label: "COOP SICREDI SUDOESTE MT/PA [32995755]"},
    {value: "26191078", label: "COOP SICREDI SUL DO MARANHÃO [26191078]"},
    {value: "03793242", label: "COOP SICREDI SUL SC [03793242]"},
    {value: "03212823", label: "COOP SICREDI TRADIÇÕES RS [03212823]"},
    {value: "24654881", label: "COOP SICREDI UNIÃO MS/TO [24654881]"},
    {value: "10348181", label: "COOP SICREDI VALE LITORAL SC [10348181]"},
    {value: "04237413", label: "COOP SICREDI VALE SÃO FRANCISCO [04237413]"},
    {value: "32983165", label: "COOP SICREDI VL DO CERRADO [32983165]"},
    {value: "05888589", label: "COOP SUL [05888589]"},
    {value: "08253539", label: "COOP SULCREDI AMPLEA [273]"},
    {value: "08075352", label: "COOP TRANSPOCRED [08075352]"},
    {value: "01572667", label: "COOP UNIPRIME SUL [01572667]"},
    {value: "16779741", label: "COOP V. ALTO VALE [16779741]"},
    {value: "02405189", label: "COOP ÚNILOS [02405189]"},
    {value: "05463212", label: "COOPCENTRAL AILOS [085]"},
    {value: "33416108", label: "COOPCENTRAL SICOOB NOVA CENTRAL [33416108]"},
    {value: "05938780", label: "COOPER CARD IP [05938780]"},
    {value: "01330387", label: "COOPERATIVA CREHNOR [350]"},
    {value: "02475222", label: "COOPSERVIDOR ES [02475222]"},
    {value: "37880206", label: "CORA SCFI [403]"},
    {value: "36741675", label: "CORPX BANK MÚLTIPLO [36741675]"},
    {value: "25606237", label: "CPC VALE DO RIO DOCE [25606237]"},
    {value: "27302181", label: "CRED.UFES [427]"},
    {value: "05979692", label: "CREDCREA [05979692]"},
    {value: "78157146", label: "CREDIALIANCA CCR [098]"},
    {value: "81723108", label: "CREDICOAMO [010]"},
    {value: "39676772", label: "CREDIFIT SCD S.A. [452]"},
    {value: "39416705", label: "CREDIHOME SCD [443]"},
    {value: "62109566", label: "CREDISAN CC [089]"},
    {value: "04632856", label: "CREDISIS - CENTRAL DE CC [097]"},
    {value: "05439425", label: "CREDISIS CAPITALCREDI CCLA DO ACRE [05439425]"},
    {value: "06975532", label: "CREDISIS COOPESA [06975532]"},
    {value: "03222753", label: "CREDISIS CREDIARI COOP LTDA. [097]"},
    {value: "04985665", label: "CREDISIS OESTE - CCI DO OESTE [04985665]"},
    {value: "26563270", label: "CREDISIS PRIMACREDI CC [26563270]"},
    {value: "03985375", label: "CREDISIS SUDOESTE/RO [03985375]"},
    {value: "07494300", label: "CREDISIS/CREDISUL CC [07494300]"},
    {value: "12599971", label: "CREDITÁ S.A. CFI [12599971]"},
    {value: "04608925", label: "CREDJUST - CCM INTEGRANTES DA [04608925]"},
    {value: "39664698", label: "CREDSYSTEM SCD S.A. [428]"},
    {value: "60779196", label: "CREFISA S.A. CFI [60779196]"},
    {value: "10398952", label: "CRESOL CONFEDERAÇÃO [133]"},
    {value: "10143743", label: "CREVISC [10143743]"},
    {value: "31666182", label: "CRONOS SOLUÇÕES PARA FINTECHS [31666182]"},
    {value: "01896779", label: "CSU DIGITAL IP S.A. [01896779]"},
    {value: "38224857", label: "DELCRED SCD S.A. [435]"},
    {value: "48584954", label: "DGBK CREDIT S.A. - SCD [575]"},
    {value: "39929224", label: "DIZCONTA [39929224]"},
    {value: "25021356", label: "DLOCAL BRASIL IP S.A. [25021356]"},
    {value: "91669747", label: "DM SA CFI [91669747]"},
    {value: "22371651", label: "DMCARD [22371651]"},
    {value: "13370835", label: "DOCK IP S.A. [301]"},
    {value: "27126513", label: "DOLARAPP [27126513]"},
    {value: "32024691", label: "DOTZPAY IP [32024691]"},
    {value: "19037276", label: "E-PREPAG [19037276]"},
    {value: "37205447", label: "E2 IP LTDA. [37205447]"},
    {value: "22181404", label: "EASY PAGO [22181404]"},
    {value: "21018182", label: "EBANX IP LTDA. [383]"},
    {value: "13059145", label: "EBURY BCO DE CÂMBIO S.A. [144]"},
    {value: "33053580", label: "ECOMOVI [33053580]"},
    {value: "09089356", label: "EFÍ S.A. - IP [364]"},
    {value: "35990763", label: "ENOQ BANK [35990763]"},
    {value: "33641877", label: "EQUIS BANK [33641877]"},
    {value: "00714671", label: "EWALLY IP S.A. [534]"},
    {value: "32906701", label: "EXPAG SOLUÇÕES EM PAGAMENTOS [32906701]"},
    {value: "08673569", label: "F D GOLD DTVM LTDA [395]"},
    {value: "03856113", label: "F2B [03856113]"},
    {value: "10789035", label: "FACILITA IP S.A. [10789035]"},
    {value: "39738065", label: "FFCRED SCD S.A. [510]"},
    {value: "04307598", label: "FIDUCIA SCMEPP LTDA [382]"},
    {value: "04962772", label: "FISERV DO BRASIL IP [04962772]"},
    {value: "13203354", label: "FITBANK IP [450]"},
    {value: "23114447", label: "FLAGSHIP IP LTDA [566]"},
    {value: "33370115", label: "FURNAS [33370115]"},
    {value: "51212088", label: "G5 SCD SA [589]"},
    {value: "30765018", label: "GALAX PAY IP S.A. [30765018]"},
    {value: "11760553", label: "GAZINCRED S.A. SCFI [478]"},
    {value: "37763847", label: "GERU SCD S.A. [37763847]"},
    {value: "11165756", label: "GLOBAL SCM LTDA [384]"},
    {value: "33630661", label: "GOWD IP LTDA. [33630661]"},
    {value: "39331592", label: "GRECALE SOLUCOES EM MEIOS DE P [39331592]"},
    {value: "02347114", label: "GREENCRED CC [02347114]"},
    {value: "04849745", label: "HBI SCD [540]"},
    {value: "39669186", label: "HEMERA DTVM LTDA. [448]"},
    {value: "27970567", label: "HINOVA PAY IP S.A. [674]"},
    {value: "44292580", label: "HR DIGITAL SCD [523]"},
    {value: "07693858", label: "HSCM SCMEPP LTDA. [312]"},
    {value: "02507780", label: "IBBA [02507780]"},
    {value: "16695922", label: "ID CTVM [439]"},
    {value: "45860531", label: "IDEA MAKER IP LTDA [45860531]"},
    {value: "04306351", label: "INDEPENDÊNCIA CC [04306351]"},
    {value: "82842386", label: "INFOPAGO [82842386]"},
    {value: "37511258", label: "INOVANTI IP S.A. [37511258]"},
    {value: "11491029", label: "IP4Y IP LTDA. [11491029]"},
    {value: "34747388", label: "ISSUER IP LTDA. [597]"},
    {value: "60701190", label: "ITAU UNIBANCO S.A. [341]"},
    {value: "15111975", label: "IUGU IP S.A. [401]"},
    {value: "40475846", label: "J17 - SCD S/A [451]"},
    {value: "49288113", label: "KANASTRA CFI [559]"},
    {value: "34678263", label: "KREDIT IP [34678263]"},
    {value: "34088029", label: "LISTO SCD S.A. [397]"},
    {value: "19981015", label: "LOGCARD BRASIL [19981015]"},
    {value: "31985422", label: "LYRA COLLECT [31985422]"},
    {value: "21995256", label: "MAG IP LTDA. [560]"},
    {value: "13884775", label: "MAGALUPAY [396]"},
    {value: "44683140", label: "MAGNUM SCD [511]"},
    {value: "14615234", label: "MAPBANK [14615234]"},
    {value: "45548763", label: "MAPS IP LTDA. [592]"},
    {value: "28269650", label: "MB INVESTIMENTOS [28269650]"},
    {value: "03575699", label: "MEDCRED CC [03575699]"},
    {value: "11351086", label: "MERCADO BITCOIN IP LTDA [576]"},
    {value: "10573521", label: "MERCADO PAGO IP LTDA. [323]"},
    {value: "51834986", label: "MH SCD S.A. [51834986]"},
    {value: "45756448", label: "MICROCASH SCMEPP LTDA. [537]"},
    {value: "09464032", label: "MIDWAY S.A. - SCFI [358]"},
    {value: "37424665", label: "MODABANK [37424665]"},
    {value: "46026562", label: "MONETARIE SCD [526]"},
    {value: "30153943", label: "MONEY CLOUD [30153943]"},
    {value: "31166683", label: "MOUNT PAY [31166683]"},
    {value: "50871921", label: "MT IP S.A. [681]"},
    {value: "39576810", label: "MUITO IP LTDA. [39576810]"},
    {value: "32343119", label: "MÊNTORE BANK [32343119]"},
    {value: "06255692", label: "NDD [06255692]"},
    {value: "12573115", label: "NEL3 PAY IP LTDA. [12573115]"},
    {value: "20855875", label: "NEON PAGAMENTOS S.A. IP [536]"},
    {value: "37319859", label: "NEXT SERVICOS [37319859]"},
    {value: "40710595", label: "NG CASH IP [40710595]"},
    {value: "01648418", label: "NSTECH IP INSTITUICAO DE PAGAM [01648418]"},
    {value: "18236120", label: "NU PAGAMENTOS - IP [260]"},
    {value: "38129006", label: "NUMBRS SCD S.A. [419]"},
    {value: "38297374", label: "NUVENDE [38297374]"},
    {value: "30980539", label: "OKTO IP [546]"},
    {value: "60850229", label: "OMNI BANCO S.A. [613]"},
    {value: "35210410", label: "ONEKEY PAYMENTS IP S.A. [659]"},
    {value: "29477089", label: "ONLY UP [29477089]"},
    {value: "39519944", label: "OPEA SCD [535]"},
    {value: "23791922", label: "ORUS PRIME DIGITAL LTDA [23791922]"},
    {value: "78632767", label: "OURIBANK S.A. [712]"},
    {value: "37839059", label: "OWEM PAY [37839059]"},
    {value: "25104230", label: "PAGARE IP S.A. [651]"},
    {value: "71962609", label: "PAGARE [71962609]"},
    {value: "23149892", label: "PAGBEM [23149892]"},
    {value: "17819084", label: "PAGCERTO IP LTDA. [17819084]"},
    {value: "34471744", label: "PAGME IP LTDA [660]"},
    {value: "48176336", label: "PAGOL SCD [48176336]"},
    {value: "30944783", label: "PAGPRIME IP [557]"},
    {value: "08561701", label: "PAGSEGURO INTERNET IP S.A. [290]"},
    {value: "40478262", label: "PAGSTAR IP S.A. [40478262]"},
    {value: "03816413", label: "PAGUEVELOZ IP LTDA. [03816413]"},
    {value: "14388334", label: "PARANA BCO S.A. [254]"},
    {value: "03311443", label: "PARATI - CFI S.A. [326]"},
    {value: "40820176", label: "PAY BROKERS IP [40820176]"},
    {value: "44815065", label: "PAY2ALL IP LTDA. [44815065]"},
    {value: "20757199", label: "PAY4FUN IP S.A. [561]"},
    {value: "43180355", label: "PEFISA S.A. - C.F.I. [174]"},
    {value: "23197081", label: "PGWEB [23197081]"},
    {value: "31752308", label: "PHI PAGAMENTOS [31752308]"},
    {value: "09516419", label: "PICPAY BANK - BANCO MÚLTIPLO S.A [079]"},
    {value: "22896431", label: "PICPAY [380]"},
    {value: "17079937", label: "PINBANK IP [529]"},
    {value: "17768068", label: "PINPAG IP S.A. [17768068]"},
    {value: "38314747", label: "PLANIUM INSTITUICAO DE PAGAMEN [38314747]"},
    {value: "05684234", label: "PLANNER SOCIEDADE DE CRÉDITO DIRETO [410]"},
    {value: "07136847", label: "PONTO INFO [07136847]"},
    {value: "31861005", label: "PRIMEPAG [31861005]"},
    {value: "40276692", label: "PROTEGE CASH [563]"},
    {value: "35713491", label: "PROTOTYPE IP S.A. [35713491]"},
    {value: "20308187", label: "PROVER PROMOCAO DE VENDAS IP LTDA. [588]"},
    {value: "31818873", label: "QESH IP LTDA. [31818873]"},
    {value: "32402502", label: "QI SCD S.A. [329]"},
    {value: "01722480", label: "QUERO-QUERO VERDECARD IP S.A. [01722480]"},
    {value: "36272465", label: "REAG IP [36272465]"},
    {value: "34829992", label: "REAG TRUST DTVM [528]"},
    {value: "11275560", label: "RECARGAPAY IP LTDA. [357]"},
    {value: "40473435", label: "REPASSES IP S.A. [590]"},
    {value: "51342763", label: "REVOLUT SCD S.A. [620]"},
    {value: "12815827", label: "ROADCARD IP S.A. [12815827]"},
    {value: "31711972", label: "S3 BANK IP S.A. [31711972]"},
    {value: "52440987", label: "SANTS SCD S.A. [614]"},
    {value: "35535240", label: "SAQ [35535240]"},
    {value: "42259084", label: "SBCASH SCD [482]"},
    {value: "00329598", label: "SEFER INVESTIMENTOS DTVM LTDA [407]"},
    {value: "47873449", label: "SER FINANCE SCD S.A. [530]"},
    {value: "10773370", label: "SERVELOJA [10773370]"},
    {value: "03973814", label: "SERVICOOP [190]"},
    {value: "29759316", label: "SERVNET IP LTDA. [29759316]"},
    {value: "38372267", label: "SHOPEE [38372267]"},
    {value: "05203605", label: "SICOOB AMAZÔNIA [05203605]"},
    {value: "32430233", label: "SICOOB CONEXÃO [32430233]"},
    {value: "31804966", label: "SICOOB COOPERMAIS [31804966]"},
    {value: "33924028", label: "SICOOB COOPVALE [33924028]"},
    {value: "64739121", label: "SICOOB CRED COPERCANA [64739121]"},
    {value: "00952415", label: "SICOOB CREDFAZ [00952415]"},
    {value: "47074323", label: "SICOOB CREDICONSUMO CC [47074323]"},
    {value: "41931221", label: "SICOOB CREDICOOP [41931221]"},
    {value: "37255049", label: "SICOOB CREDIGOIÁS CC [756]"},
    {value: "71336432", label: "SICOOB CREDIMED - CCLA DE UBERABA [71336432]"},
    {value: "03358914", label: "SICOOB CREDIROCHAS [756]"},
    {value: "01864151", label: "SICOOB CREDISERV [01864151]"},
    {value: "03632872", label: "SICOOB CREDISUL [03632872]"},
    {value: "02448839", label: "SICOOB CREDIUNIÃO [02448839]"},
    {value: "54190525", label: "SICOOB CRESSEM [54190525]"},
    {value: "04649337", label: "SICOOB DFMIL [04649337]"},
    {value: "05856736", label: "SICOOB EMPRESARIAL [05856736]"},
    {value: "04120633", label: "SICOOB EMPRESAS RJ [756]"},
    {value: "02931668", label: "SICOOB FLUMINENSE [02931668]"},
    {value: "37076205", label: "SICOOB JUDICIÁRIO [37076205]"},
    {value: "02493000", label: "SICOOB LESTE [02493000]"},
    {value: "02382755", label: "SICOOB POTIGUAR [02382755]"},
    {value: "32467086", label: "SICOOB SUL [32467086]"},
    {value: "32474884", label: "SICOOB SUL-LITORÂNEO [32474884]"},
    {value: "00815319", label: "SICOOB SUL-SERRANO [00815319]"},
    {value: "02794761", label: "SICOOB UFVCREDI [02794761]"},
    {value: "01259518", label: "SICOOB UNIMAIS CENTRO LESTE PAULIST [01259518]"},
    {value: "03428338", label: "SICREDI CREDUNI [748]"},
    {value: "87781530", label: "SICREDI INTEGRAÇÃO ESTADOS RS/SC/MG [87781530]"},
    {value: "07206072", label: "SICREDI NOVOS HORIZONTES PR/SP/RJ [07206072]"},
    {value: "14483955", label: "SILIUM INFRAESTRUTURA TECNOLOG [14483955]"},
    {value: "68757681", label: "SIMPAUL [365]"},
    {value: "02398976", label: "SISPRIME DO BRASIL - COOP [084]"},
    {value: "37470405", label: "SMART SOLUTIONS GROUP IP LTDA [615]"},
    {value: "15173776", label: "SOCIAL BANK S/A [412]"},
    {value: "03881423", label: "SOCINAL S.A. CFI [425]"},
    {value: "09210106", label: "SOCRED SA - SCMEPP [183]"},
    {value: "37292981", label: "SOFFY SOLUCOES DE PAGAMENTOS [37292981]"},
    {value: "44705774", label: "SOMAPAY SCD S.A. [520]"},
    {value: "20018183", label: "STARK BANK S.A. - IP [665]"},
    {value: "39908427", label: "STARK SCD S.A. [462]"},
    {value: "00394460", label: "STN [00394460]"},
    {value: "16501555", label: "STONE IP S.A. [197]"},
    {value: "37241230", label: "SUMUP SCD S.A. [404]"},
    {value: "28595756", label: "SUN SOLUCOES DE PAGAMENTOS [28595756]"},
    {value: "31680151", label: "SWAP IP S.A. [31680151]"},
    {value: "14821124", label: "TARGET BANK [14821124]"},
    {value: "27084098", label: "TRANSFEERA IP S.A. [593]"},
    {value: "47133056", label: "TRANSFERO IP LTDA. [47133056]"},
    {value: "37753531", label: "TRANSFERSMILE IP [37753531]"},
    {value: "40654622", label: "TRINUS SCD S.A. [444]"},
    {value: "49931906", label: "TRIO IP LTDA. [619]"},
    {value: "00604122", label: "TRIVALE [00604122]"},
    {value: "26615279", label: "TYCOON TECHNOLOGY IIP S.A [685]"},
    {value: "42047025", label: "UNAVANTI SCD S/A [460]"},
    {value: "04445917", label: "UNICRED COALIZÃO [04445917]"},
    {value: "00315557", label: "UNICRED DO BRASIL [136]"},
    {value: "01526924", label: "UNICRED HORIZONTES [01526924]"},
    {value: "02641032", label: "UNICRED PONTO CAPITAL [02641032]"},
    {value: "01705236", label: "UNICRED PROSPERAR [01705236]"},
    {value: "02833202", label: "UNICRED SUDOESTE DA BAHIA [02833202]"},
    {value: "03046391", label: "UNIPRIME COOPCENTRAL LTDA. [099]"},
    {value: "01848322", label: "UNIPRIME DO IGUAÇU - CC POUP INV [01848322]"},
    {value: "01286361", label: "UNIPRIME PIONEIRA CC [01286361]"},
    {value: "35542555", label: "UNLIMIT IP LTDA. [35542555]"},
    {value: "35977097", label: "UP.P SEP S.A. [373]"},
    {value: "53842122", label: "URBANO S.A. SCFI [761]"},
    {value: "39587424", label: "UY3 SCD S/A [457]"},
    {value: "32192325", label: "UZZIPAY IP S.A. [552]"},
    {value: "38320462", label: "V3 IP S.A. [38320462]"},
    {value: "28220872", label: "VALEPAY [28220872]"},
    {value: "23273917", label: "VALLOO PAGAMENTOS [23273917]"},
    {value: "35858847", label: "VIATECH [35858847]"},
    {value: "33423888", label: "VILLELA IP S.A. [33423888]"},
    {value: "03817702", label: "VOLUS IP [03817702]"},
    {value: "30385259", label: "VOLUTI [30385259]"},
    {value: "22610500", label: "VORTX DTVM LTDA. [310]"},
    {value: "32708748", label: "WE PAY OUT IP LTDA. [662]"},
    {value: "23862762", label: "WILL FINANCEIRA S.A.CFI [280]"},
    {value: "28806775", label: "WISEPAY [28806775]"},
    {value: "54811417", label: "WOOVI IP LTDA. [694]"},
    {value: "29408213", label: "WORK 8 [29408213]"},
    {value: "07322044", label: "XISNET [07322044]"},
    {value: "37911077", label: "YAW IP S.A. [37911077]"},
    {value: "52586293", label: "Z-ON SCD S.A. [632]"},
    {value: "35810871", label: "Z1 IP LTDA. [586]"},
    {value: "05351887", label: "ZEMA CFI S/A [359]"},
    {value: "26264220", label: "ZERO [671]"},
    {value: "26356125", label: "ZIG [26356125]"},
    {value: "19468242", label: "ZOOP MEIOS DE PAGAMENTO [595]"},
    {value: "34335592", label: "ÓTIMO SCD S.A. [355]"},
  ]
}